import { Link, useLocation } from 'react-router-dom';

function Layout({ children }) {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-3">
              <svg className="w-10 h-10" viewBox="0 0 200 240">
                <defs>
                  <linearGradient id="lobster-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#FF7F50" />
                    <stop offset="100%" stopColor="#FF4500" />
                  </linearGradient>
                  <linearGradient id="silver-shield-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#E0E0E0" />
                    <stop offset="50%" stopColor="#C0C0C0" />
                    <stop offset="100%" stopColor="#A0A0A0" />
                  </linearGradient>
                  <linearGradient id="silver-border-gradient" x1="100%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#FFFFFF" />
                    <stop offset="50%" stopColor="#D3D3D3" />
                    <stop offset="100%" stopColor="#B0B0B0" />
                  </linearGradient>
                </defs>
                <path d="M100 10 L10 50 C10 120 40 180 100 230 C160 180 190 120 190 50 L100 10Z" fill="url(#silver-shield-gradient)" stroke="url(#silver-border-gradient)" strokeWidth="8"/>
                <g transform="translate(40, 60) scale(1.0)">
                  <path d="M60 10 C30 10 15 35 15 55 C15 75 30 95 45 100 L45 110 L55 110 L55 100 C55 100 60 102 65 100 L65 110 L75 110 L75 100 C90 95 105 75 105 55 C105 35 90 10 60 10Z" fill="url(#lobster-gradient)"/>
                  <path d="M20 45 C5 40 0 50 5 60 C10 70 20 65 25 55 C28 48 25 45 20 45Z" fill="url(#lobster-gradient)"/>
                  <path d="M100 45 C115 40 120 50 115 60 C110 70 100 65 95 55 C92 48 95 45 100 45Z" fill="url(#lobster-gradient)"/>
                  <path d="M45 15 Q35 5 30 8" stroke="#FF7F50" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M75 15 Q85 5 90 8" stroke="#FF7F50" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="45" cy="35" r="6" fill="#1a1a2e"/>
                  <circle cx="75" cy="35" r="6" fill="#1a1a2e"/>
                  <circle cx="46" cy="34" r="2" fill="#00FFFF"/>
                  <circle cx="76" cy="34" r="2" fill="#00FFFF"/>
                </g>
              </svg>
              <span className="text-xl font-bold text-gray-900">ClawShield</span>
            </Link>

            <nav className="flex items-center space-x-8">
              <Link
                to="/verify"
                className={`text-sm font-medium transition-colors ${
                  isActive('/verify') ? 'text-primary-600' : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Verify Agent
              </Link>
              <a
                href="https://github.com/clawshield/protocol"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium text-gray-600 hover:text-gray-900"
              >
                Docs
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <svg className="w-8 h-8" viewBox="0 0 200 240">
                  <defs>
                    <linearGradient id="lobster-gradient-footer" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#FF7F50" />
                      <stop offset="100%" stopColor="#FF4500" />
                    </linearGradient>
                    <linearGradient id="silver-shield-gradient-footer" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#E0E0E0" />
                      <stop offset="50%" stopColor="#C0C0C0" />
                      <stop offset="100%" stopColor="#A0A0A0" />
                    </linearGradient>
                  </defs>
                  <path d="M100 10 L10 50 C10 120 40 180 100 230 C160 180 190 120 190 50 L100 10Z" fill="url(#silver-shield-gradient-footer)" strokeWidth="8"/>
                  <g transform="translate(40, 60) scale(1.0)">
                    <path d="M60 10 C30 10 15 35 15 55 C15 75 30 95 45 100 L45 110 L55 110 L55 100 C55 100 60 102 65 100 L65 110 L75 110 L75 100 C90 95 105 75 105 55 C105 35 90 10 60 10Z" fill="url(#lobster-gradient-footer)"/>
                    <path d="M20 45 C5 40 0 50 5 60 C10 70 20 65 25 55 C28 48 25 45 20 45Z" fill="url(#lobster-gradient-footer)"/>
                    <path d="M100 45 C115 40 120 50 115 60 C110 70 100 65 95 55 C92 48 95 45 100 45Z" fill="url(#lobster-gradient-footer)"/>
                    <circle cx="45" cy="35" r="6" fill="#1a1a2e"/>
                    <circle cx="75" cy="35" r="6" fill="#1a1a2e"/>
                    <circle cx="46" cy="34" r="2" fill="#00FFFF"/>
                    <circle cx="76" cy="34" r="2" fill="#00FFFF"/>
                  </g>
                </svg>
                <span className="text-white font-bold">ClawShield</span>
              </div>
              <p className="text-sm">
                Open Identity for AI Agents like OpenClaw. Trust through domain ownership verification.
              </p>
            </div>
            <div>
              <h4 className="text-white font-medium mb-4">Protocol</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/verify" className="hover:text-white">Verify Agent</Link></li>
                <li><a href="/v1/directory" className="hover:text-white">API</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-medium mb-4">Philosophy</h4>
              <ul className="space-y-2 text-sm">
                <li>No user accounts</li>
                <li>Domain is identity</li>
                <li>Zero-knowledge architecture</li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-medium mb-4">Contact</h4>
              <a
                href="https://x.com/clawshield"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-sm hover:text-white"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
                <span>@clawshield</span>
              </a>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
            The ClawShield Protocol is open source and free to use.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
